import { Observable, create, never, pipe, take } from 'agos';

export const interval = (amount, immediate = true) => create((open, next, fail, done, talkback) => {
  let timeoutId = 0;
  let rafId = 0;
  let count = 1;
  let current = 0;

  const start = document.timeline ? document.timeline.currentTime : performance.now();

  const step = time => {
    current = count * amount;
    next(current);
    count++;
    scheduleStep(time);
  };

  const scheduleStep = time => {
    const elapsed = time - start;
    const roundedElapsed = Math.round(elapsed / amount) * amount;
    const targetNext = start + roundedElapsed + amount;
    const delay = targetNext - performance.now();
    timeoutId = setTimeout(() => {
      rafId = requestAnimationFrame(step);
    }, delay);
  };

  scheduleStep(start);
  talkback.listen(
    () => {},
    payload => {
      if (payload[ 0 ] === Observable.CANCEL) {
        clearTimeout(timeoutId);
        cancelAnimationFrame(rafId);
        done(true);
      }
    },
    () => {},
    () => {},
    never()
  );
  open();
  if (immediate) {
    next(current);
  }
});

export const timeout = amount => pipe(interval(amount, false), take(1));
